import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import '../scss/main.scss';

var $ = require("jquery");

require('bootstrap/dist/js/bootstrap.bundle');

document.onreadystatechange = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (document.readyState == 'complete') {
            $('#start button').on('click', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      $(this).parent().addClass('d-none');
                      _context2.next = 3;
                      return asyncForEach($('#start .container > div'), /*#__PURE__*/function () {
                        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return sleep(1000);

                                case 2:
                                  $(item).addClass('d-none');

                                  if (!($('#start .container > div.d-none').length == 3)) {
                                    _context.next = 8;
                                    break;
                                  }

                                  $('#start').addClass('d-none');
                                  _context.next = 7;
                                  return sleep(1000);

                                case 7:
                                  userCheck();

                                case 8:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }));

                        return function (_x) {
                          return _ref3.apply(this, arguments);
                        };
                      }());

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            })));
            $('#cards').on('click', '.show-card', function (e) {
              e.preventDefault(); // $(this).closest('.transform-box').removeClass('transform-box');
            });
            $('#cards').on('click', '.check-card', /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
                var $user, $ai, userVal, aiVal;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        e.preventDefault();
                        $('.transform-box').removeClass('transform-box');
                        $user = $(this).addClass('active').parent().addClass('selected').end();
                        $ai = $('.card-box').eq(2).children().eq($('.check-card.active').index()).addClass('active');
                        _context3.next = 6;
                        return sleep(1000);

                      case 6:
                        userVal = Number($($user).data('value'));
                        aiVal = Number($($ai).data('value'));

                        if (!(userVal == aiVal)) {
                          _context3.next = 17;
                          break;
                        }

                        _context3.next = 11;
                        return sleep(1000);

                      case 11:
                        $('#score-overlay').addClass('draw').fadeIn(500);
                        _context3.next = 14;
                        return sleep(2000);

                      case 14:
                        $('#score-overlay').fadeOut(500, resetCards); // await resetCards();

                        _context3.next = 40;
                        break;

                      case 17:
                        if (!($user.data('win') == '>')) {
                          _context3.next = 30;
                          break;
                        }

                        if (!(userVal > aiVal)) {
                          _context3.next = 24;
                          break;
                        }

                        $user.addClass('win');
                        _context3.next = 22;
                        return setScore('user-score');

                      case 22:
                        _context3.next = 28;
                        break;

                      case 24:
                        if (!(userVal != aiVal)) {
                          _context3.next = 28;
                          break;
                        }

                        $ai.addClass('win');
                        _context3.next = 28;
                        return setScore('ai-score');

                      case 28:
                        _context3.next = 40;
                        break;

                      case 30:
                        if (!(userVal < aiVal)) {
                          _context3.next = 36;
                          break;
                        }

                        $user.addClass('win');
                        _context3.next = 34;
                        return setScore('user-score');

                      case 34:
                        _context3.next = 40;
                        break;

                      case 36:
                        if (!(userVal != aiVal)) {
                          _context3.next = 40;
                          break;
                        }

                        $ai.addClass('win');
                        _context3.next = 40;
                        return setScore('ai-score');

                      case 40:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this);
              }));

              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }());
            $('.check-int').each(function () {
              // console.log(Number($(this).data('check'))%1);
              if (Number($(this).data('check')) % 1 === 0) {
                $(this).text($(this).data('check'));
              }
            });
          }

        case 1:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4);
}));

function setScore(_x3) {
  return _setScore.apply(this, arguments);
}

function _setScore() {
  _setScore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(player) {
    var $box, gameOver;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            $box = $('#' + player);
            $box.text(parseInt($box.text()) + 1);

            if (!(player == 'user-score')) {
              _context5.next = 15;
              break;
            }

            $('.card-content[data-id="' + $('.card-box[data-id]').eq(1).data('id') + '"]').appendTo($('#user-cards'));
            $('#user-count').text(parseInt($('#user-count').text()) + 1);
            $('#ai-count').text(parseInt($('#ai-count').text()) - 1);
            $('#ai-score').text(parseInt($('#ai-score').text()) - 1);
            _context5.next = 9;
            return sleep(1000);

          case 9:
            $('#score-overlay').fadeIn(500);
            _context5.next = 12;
            return sleep(2000);

          case 12:
            $('#score-overlay').fadeOut(500, resetCards);
            _context5.next = 27;
            break;

          case 15:
            $('.card-content[data-id="' + $('.card-box[data-id]').eq(0).data('id') + '"]').appendTo($('#ai-cards'));
            $('#ai-count').text(parseInt($('#ai-count').text()) + 1);
            $('#user-count').text(parseInt($('#user-count').text()) - 1);
            $('#user-score').text(parseInt($('#user-score').text()) - 1);
            _context5.next = 21;
            return sleep(2000);

          case 21:
            _context5.next = 23;
            return resetCards();

          case 23:
            gameOver = _context5.sent;

            if (gameOver) {
              _context5.next = 27;
              break;
            }

            _context5.next = 27;
            return aiCheck();

          case 27:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _setScore.apply(this, arguments);
}

function userCheck() {
  $('.transform-box').eq(0).removeClass('transform-box');
}

function aiCheck() {
  return _aiCheck.apply(this, arguments);
}

function _aiCheck() {
  _aiCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            $('.transform-box').addClass('ai-check').removeClass('transform-box');
            _context6.next = 3;
            return sleep(500);

          case 3:
            $('.check-card').eq(Math.floor(Math.random() * 8)).trigger('click');

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _aiCheck.apply(this, arguments);
}

function resetCards() {
  return _resetCards.apply(this, arguments);
}

function _resetCards() {
  _resetCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            $('#score-overlay').removeClass('draw');
            $('.card-box').find('.active').removeClass('active win').end().removeClass('selected').parent().addClass('transform-box').removeClass('ai-check');
            _context7.next = 4;
            return sleep(1000);

          case 4:
            if (!(parseInt($('#user-count').text()) == 0 || parseInt($('#ai-count').text()) == 0)) {
              _context7.next = 15;
              break;
            }

            // alert('!!!! GAMEOVER !!!!');
            $('#score-box + div').addClass('invisible');

            if (parseInt($('#user-count').text()) == 0) {
              $('#ai-win').addClass('winner');
            } else {
              $('#user-win').addClass('winner');
            }

            $('#score-overlay').addClass('gameover').fadeIn(500);
            _context7.next = 10;
            return sleep(4000);

          case 10:
            $('#score-box div').addClass('mx-auto');
            $('#score-overlay').fadeOut(500);
            return _context7.abrupt("return", true);

          case 15:
            $('.card-box[data-id]').each(function (index) {
              var cardFrom = '#user-cards';
              if (index == 1) cardFrom = '#ai-cards';
              var $card = $(cardFrom + ' .card-content').eq(Math.floor(Math.random() * $(cardFrom + ' .card-content').length));
              $(this).data('id', $card.data('id')).html($card.html());

              if (index == 1) {
                $(this).find('a.check-card').each(function () {
                  var content = $(this).html();
                  var volumeBox = false;
                  if ($(this).hasClass('volume-box')) volumeBox = true;
                  $(this).replaceWith('<p ' + (volumeBox ? 'class="volume-box"' : '') + ' data-value="' + $(this).data('value') + '">' + content + '</p>');
                }).end().find('.bg-blue').remove();
              } // $card.remove();

            });
            userCheck();
            return _context7.abrupt("return", false);

          case 18:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _resetCards.apply(this, arguments);
}

function asyncForEach(_x4, _x5) {
  return _asyncForEach.apply(this, arguments);
}

function _asyncForEach() {
  _asyncForEach = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(array, callback) {
    var index;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            index = 0;

          case 1:
            if (!(index < array.length)) {
              _context8.next = 7;
              break;
            }

            _context8.next = 4;
            return callback(array[index], index, array);

          case 4:
            index++;
            _context8.next = 1;
            break;

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _asyncForEach.apply(this, arguments);
}

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}